import { render, staticRenderFns } from "./IncomeAccount.vue?vue&type=template&id=296a610e&"
import script from "./IncomeAccount.vue?vue&type=script&lang=js&"
export * from "./IncomeAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports